var map = {
	"./sms-credit-de.html": 1978,
	"./sms-credit-en.html": 1979,
	"./sms-credit-es.html": 1980,
	"./sms-credit-fr.html": 1981,
	"./sms-credit-ja.html": 1982,
	"./sms-credit-pt.html": 1983,
	"./sms-credit-zh.html": 1984
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1977;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-credit ^\.\/sms\-credit\-.*\.html$
// module id = 1977
// module chunks = 0